import type { Operation } from 'apollo-link';
import type { DefinitionNode, OperationDefinitionNode } from 'graphql';

function isOperationDefinitionNode(node: DefinitionNode): node is OperationDefinitionNode {
	return 'operation' in node;
}

// keeping this for now since we don't actually check for directives
// on subscription types
function isWSOperation() {
	return (operation: Operation) => {
		if (!operation.query.definitions) return false;
		for (const { operation: type } of operation.query.definitions.filter(
			isOperationDefinitionNode,
		)) {
			if (type === 'subscription') {
				return true;
			}
		}
		return false;
	};
}

export const isWS = isWSOperation();
